import React from "react";
import styles from "./MediaTeaser.module.less";
import Button from "../Button/Button";

export interface Props {
    heading: string;
    preHeading?: string;
    body?: string;
    image: string;
    linkText: string;
    linkTo: string;
    imagePosition?: "left" | "right";
}

export default function MediaTeaser(props: Props) {
    return (
        <section className={[styles.MediaTeaser, props.imagePosition === "right" ? styles["MediaTeaser--imageRight"] : null].join(" ")}>
            <div className={styles["MediaTeaser-media"]}>
                <img src={props.image} alt={props.heading} />
            </div>
            <div className={styles["MediaTeaser-content"]}>
                {props.preHeading ? <span className={styles["MediaTeaser-preHeading"]}>{props.preHeading}</span> : null}
                <h2 className={styles["MediaTeaser-heading"]}>{props.heading}</h2>

                <p dangerouslySetInnerHTML={{__html: props.body ?? ""}}></p>

                <Button theme="grey" small to={props.linkTo}>
                    {props.linkText}
                </Button>
            </div>
        </section>
    );
}
